declare global {
    interface Window {
      lang: string;
    }
  }
  window.lang = navigator.language.split("-")[0];
  try {
    const data = JSON.parse(localStorage.outdooraData)
    if(data.language) {
      window.lang = data.language
    }
  }catch{}
  
  const i18n: any = {
    en: {
      see_on_map: "See on map",
      back: "Back",
      total: "Total",
      bike_tours_title: "Best Bike tours",
      show_all_tours: "Show all tours",
      load_more_tours: "Load more tours",
      loading: "Loading",
      search: 'Search',
      search_placeholder: "Find a self guided tour...",
      Days: "Days",
      show_more: "Show more",
      show_less: "Show less",
      tour_price: "Tour price",
      Lista: "Back",
      Mappa: "Map",
      Tour: "Tours",
      Destinazioni: "Destinations",
      tours_in_destination: "{{count}} tours in this destination",
      see_all_results: "See all results for",
      no_results_for: "No results for",
      no_tours_found: "No tours found for",
      search_results_for: "Search results for",
      tours_in: "Tours in",
      my_pos: "My position",
      the_tour: "Tours",
      favourite_locations: "Best Locations",
      contact: "Customer care",
      call: "Call",
      write: "Email",
      x_person: "per person",
      tour_date: "Date of the tour",
      extra_device_title: "Extra devices",
      extra_device_desc: "The track will be available on only one smartphone device. Do you want to enable the navigator on more than one phone?",
      rent_title: "Extras",
      rent_desc: "You don't need anything! Rent everything you need for your tour!",
      reasume: "Reasume",
      tour_duration: "Tour duration",
      track_unlock: "Track unlock",
      day: "day",
      day_plurar: "day{{plural}}",
      o: ' ',
      i: 's',
      included_device_text: "1 phone device included 0€",
      extra_device: "Extra device",
      selected_rent: "Selected rents",
      add_chart_btn: "Add to chart",
      resume_title: "Summary",
      start_point: "Start from",
      duration: "Estimate duration",
      track_length: "Track length",
      difficulty: "Difficulty",
      offered_by: "Offered by",
      discover_and_reserve: "Discover and reserve",
      add: "Add",
      close_title: "Self Guided Tour close to you",
      jumbo_title: "Discover Italy on two wheels",
      jumbo_subtitle: "Discover our self guided tour",
      anonymous: "Anonymous",
      verify_btn: "Check availability",
      next: 'Next',
      info_and_payment: "Info & Payment",
      info_and_payment_desc: "Insert your informations and the credit card to finish the payment",
      go_to_pay_btn: "Go to Payment",
      confirm_and_pay: "Confirm and pay",
      verify_btn2: "Confirm date",
      verify_btn3: "Change date",
      in_breve: 'The activity',
      in_breve_desc: "Outdoora is a navigation app designed for your tours — a guide that’s always with you. It helps you find your way step by step with interactive GPS maps and turn-by-turn navigation (even offline), highlighting points of interest in advance and telling their stories through info sheets, photos, and fun facts. You’ll receive real-time alerts about route changes, travel times, and elevation gains, as well as suggestions on where to stop (mountain huts, fountains, rest areas, and bike points).",
      date_0: "When?",
      date_1: "Select a date",
      pay_final_btn: "Confirm and pay",
      back_to_home_btn: "Back to homepage",
      view_orders: "View orders",
      print_recipe: "Download instructions now",
      payment_success: "Well Done!",
      collaborate: "Collaborate with us",
      payment_methods: "Payment methods",
      login_google_title: "Do you want to keep the history of your orders and your data on all your devices? Login with Google.",
      language: "Language",
      currency: "Currency",
      as_shop: "As bike rental",
      as_tour_operator: "As Tour Operator",
      free_cancel_title: "Free cancellation",
      free_cancel_desc: "Until 24 hours before the tour's starting date",
      free_cancel_desc_long: "You can cancel the tour free of charge up to 24 hours before the selected start date",
      pay_now_title: 'Pay now',
      pay_now_desc: "If you cancel within the allowed time, you will be refunded the full amount.",
      poi_title: "Point of interest",
      included_title: "What’s included",
      inc_1: "Outdoora app for one device",
      inc_2: "Phone holder",
      not_included_title: "What’s not included",
      ninc_1: "Food and drinks",
      ninc_2: "EXTRA: E-bike and helmet rental",
      ninc_3: "EXTRA: Outdoora app for additional devices",
      important_title: "Important",
      imp_1: "Comfortable shoes",
      imp_2: "Tight-fitting pants at the ankles",
      imp_3: "Sunglasses",
      imp_4: "Raincoat",
      full_desc_title: "Full description",
      eq_extra_device_name: "Extra Device",
      eq_extra_device_desc: "Add an additional device that can navigate the track with the Outdoora app",
      eq_bike_name: "E-bike",
      eq_bike_desc: "With suspension and available in various sizes",
      eq_elmet_name: "Helmet",
      eq_elmet_desc: "Available in various sizes",
      no_eq_selected_title: "No equipment selected",
      no_eq_selected_desc: "Are you sure you want to proceed without renting any equipment? By doing so, you will only purchase the self-guided tour and will need to use your own bike and personal gear",
      no_eq_ok: "Confirm and go to cart",
      no_eq_cancel: "Cancel",
      like_also_title: "You may also like...",
      my_payments_title: "Purhcase History",
      tour_date2: "Tour Date",
      paied: "Paied",
      status: 'Status',
      partecipants: 'Partecipants',
      account_pending: 'In progress...',
      account_waiting: 'Waiting for approval...',
      account_done: 'Done',
      account_refounded: 'Refounded',
      datetime_title: "Insert the time when you will pick up the rental equipment.",
      slot_too_late: "no longer available",
      tall_title: "Insert the height of the participants",
      preferite_btn: "Explore our tours",
      preferite_jumbo_title: "My favorites",
      preferite_title: "You haven't saved any favorite tours yet.",
      preferite_d1: "tap the heart icon ",
      preferite_d2: " to save a tour to your favorites",
      user_tall_unit: "Unit",
      user_tall: "Driver tall",
      user_tall_error: "Tall out of range",
      centimeter: "Centimeter",
      feet: "Feet",
      inch: "Inch",
      payment_success_title: "Your payment was successful; you will receive a confirmation email.",
      payment_success_desc: "You will also find all this information in the email we sent you. You can also download the instructions now ⬇",
      payment_nodevice: "You didn't add EXTRA devices during checkout, so OUTDOORA can only be activated on one phone",
      payment_devices: "OUTDOORA can be activated on {{devices}} devices",
      payment_activate_link: "Click here to activate the app",
      payment_or: "OR",
      payment_scan_for_active: "SCAN THE QR CODE FROM THE OUTDOORA APP to ACTIVATE!",
      payment_scan_desc: "From the OUTDOORA app, scan the activation QR code now",
      payment_scan_title: "Downloaded it?",
      payment_approval_desc: "It could take a few hours or a couple of days; we will contact you via email at the address provided as soon as we receive confirmation from the shop",
      payment_approval_title: "Wait for shop confirmation regarding rental availability included with your self-guided tour.",
      payment_check_mail: "Check your EMAIL!",
      payment_scan_download: "Scan to download the app",
      payment_download: "Download the App",
      payment_or_scan_download: "Or scan to install",
      payment_desc2: "A real-time navigation experience that will guide you along the route to your destination",
      payment_title2: "Download OUTDOORA to use our Self-guided Tour",
      payment_noworry: "Don't worry",
    },
    it: {
      see_on_map: "Vedi su mappa",
      back: "Indietro",
      total: "Totale",
      bike_tours_title: "I migliori Self Guided tour",
      show_all_tours: "Mostra tutti i tour",
      load_more_tours: "Carica altri tour",
      loading: "Caricamento",
      search_placeholder: "Trova self guided tour...",
      search: 'Cerca',
      Days: "Giorni",
      show_more: "Mostra altro",
      show_less: "Mostra meno",
      tour_price: "Costo del tour",
      Lista: "Indietro",
      Mappa: "Mappa",
      Tour: "Tour",
      Destinazioni: "Destinazioni",
      tours_in_destination: "{{count}} tour in questa destinazione",
      see_all_results: "Vedi tutti i risultati per",
      no_results_for: "Nessun risultato per",
      no_tours_found: "Nessun tour trovato per",
      search_results_for: "Risultati di ricerca per",
      tours_in: "Tour in",
      my_pos: "La mia posizione",
      the_tour: "I tour",
      favourite_locations: "Le migliori località",
      contact: "Assistenza",
      call: "Chiamaci",
      write: "Scrivici",
      x_person: "a persona",
      tour_date: "Data in cui effettuerai il tour",
      extra_device_title: "Dispositivi extra",
      extra_device_desc: "Latraccia sarà disponibile per un solo dispositivo smarthphone, vuoi abilitare il navigatore su più di un telefono?",
      rent_title: "Selaziona Extra",
      rent_desc: "Non hai bisogno di niente! Noleggia tutto il necessario per il tuo tour!",
      reasume: "Riepilogo",
      tour_duration: "Durata tour",
      track_unlock: "Sblocco traccia",
      day: "giorno",
      day_plurar: "giorn{{plural}}",
      o: 'o',
      i: 'i',
      included_device_text: "1 dispositivo smartphone incluso 0€",
      extra_device: "Dispositivo aggiuntivo",
      selected_rent: "Noleggi selezionati",
      add_chart_btn: "Aggiungi al carrello",
      resume_title: "Informazioni sull'attività",
      start_point: "Punto di partenza",
      duration: "Durata stimata",
      track_length: "Lunghezza del percorso",
      difficulty: "Difficoltà",
      offered_by: "Offerto da",
      discover_and_reserve: "Scopri di più e prenota!",
      add: "Aggiungi",
      jumbo_title: "Alla scoperta dell'italia in bicicletta",
      jumbo_subtitle: "Scopri i nostri tour auto-guidati",
      close_title: "Self Guided Tour vicini a te",
      anonymous: "Anonimo",
      verify_btn: "Verifica disponibilità",
      next: "Avanti",
      info_and_payment: "Informazioni e pagamento",
      info_and_payment_desc: "Inserisci i tuoi dati e la tua carta per terminare l'acquisto",
      go_to_pay_btn: "Vai al pagamento",
      confirm_and_pay: "Conferma e paga",
      verify_btn2: "Conferma data",
      verify_btn3: "Cambia data",
      in_breve: "L'attività in breve",
      in_breve_desc: "Outdoora è un'app di navigazione pensata per i tuoi tour: una guida sempre con te. Ti orienta tappa dopo tappa con mappe GPS interattive e navigazione passo-passo (anche offline), segnala in anticipo i punti di interesse e li racconta con schede, foto e curiosità. Ricevi avvisi in tempo reale su deviazioni, tempi di percorrenza e dislivelli, oltre a suggerimenti su dove fermarti (rifugi, fontane, punti ristoro e bike-point).",
      date_0: "Quando?",
      date_1: "Seleziona una data",
      pay_final_btn: "Conferma e paga",
      back_to_home_btn: "Torna alla home page",
      view_orders: "Visualizza ordini",
      print_recipe: "Scarica istruzioni ora",
      payment_success: "Pagamento effettuato",
      collaborate: "Collabora con noi",
      payment_methods: "Metodi di pagamento",
      login_google_title: "Vuoi mantenero lo storico dei tuoi orgini e i tuoi dati su titti i dispositivi? Accedi con Google.",
      language: "Lingua",
      currency: "Valuta",
      as_shop: "Come noleggio di bici",
      as_tour_operator: "Come Tour Operator",
      free_cancel_title: "Cancellazione gratuita",
      free_cancel_desc: "Fino a 24 ore prima dalla data di inizio del tour",
      free_cancel_desc_long: "Puoi effettuare la cancellazione gratuita del tour fino a 24 ore prima della data di inizio selezionata.",
      pay_now_title: 'Paga ora',
      pay_now_desc: "Se cancelli nei tempi consentiti ti verrà timborsato l'intero importo",
      poi_title: "Punti di interesse",
      included_title: "Cosa è incluso",
      inc_1: "App Outdoora per un dispositivo",
      inc_2: "Porta telefono",
      not_included_title: "Cosa non è incluso",
      ninc_1: "cibo e bevande",
      ninc_2: "EXTRA: Noleggio E bike e casco",
      ninc_3: "EXTRA: App Outdoora per dispositivi extra",
      important_title: "Importante",
      imp_1: "scarpe comode",
      imp_2: "pantaloni stetti alla caviglie",
      imp_3: "occhiali da sole",
      imp_4: "impermeabile",
      full_desc_title: "Descrizione completa",
      eq_extra_device_name: "Dispositivo Extra",
      eq_extra_device_desc: "Aggiungi un ulteriore dispositivo che possa navigare la traccia con Outdoora app",
      eq_bike_name: "E-bike",
      eq_bike_desc: "ammortizzata e disponibile in varie taglie",
      eq_elmet_name: "Casco",
      eq_elmet_desc: "disponibile in varie misure",
      no_eq_selected_title: "Nessun noleggio selezionato",
      no_eq_selected_desc: "Sei sicuro di voler proseguire senza noleggiare nessuna attrezzatura? Così facendo acquisterai solo il self-guided tour e dovrai utilizzare la tua bicicletta e attrezzatura personale",
      no_eq_ok: "Conferma e vai al carrello",
      no_eq_cancel: "Annulla",
      like_also_title: "Ti potrebbe piacere anche...",
      my_payments_title: "Storico pagamenti",
      tour_date2: "Data del tour",
      paied: "Pagato",
      status: 'Stato',
      partecipants: 'Partecipanti',
      account_pending: 'In corso...',
      account_waiting: 'In attesa di approvazione...',
      account_done: 'Completati',
      account_refounded: 'Rimborsati',
      datetime_title: "Inserisci l'orario in cui ritirerai l'attrezzatura a noleggio",
      slot_too_late: "non più disponibile",
      tall_title: "Inserisci l'altezza dei partecipanti",
      preferite_btn: "Esplora i nostri tour",
      preferite_jumbo_title: "I miei preferiti",
      preferite_title: "Non hai ancora salvato nessun tour tra i preferiti.",
      preferite_d1: "premi sul cuore ",
      preferite_d2: " per salvare un tour tra i preferiti ",
      user_tall_unit: "Unità di misura",
      user_tall: "Altezza conducente",
      user_tall_error: "Altezza fuori intervallo minimo/massimo",
      centimeter: "Centimetri",
      feet: "Piedi",
      inch: "Pollici",
      payment_success_title: "Il pagamento è stato effettuato con successo, riceverai una email di conferma.",
      payment_success_desc: "Troverai tutte queste informazione anche nella mail che ti abbiamo inviato! Puoi anche scaricarle qui sotto! ⬇",
      payment_nodevice: "Non hai aggiunto dispositivi EXTRA in fase di acquisto quindi OUTDOORA potrà essere attivata solo su un telefono",
      payment_devices: "OUTDOORA può essere attivata su {{devices}} dispositivi",
      payment_activate_link: "Clicca qui per attivare l'app",
      payment_or: "OPPURE",
      payment_scan_for_active: "SCANSIONA IL QR CODE DALLA APP OUTDOORA per ATTIVARTI!",
      payment_scan_desc: "Dalla app di OUTDOORA scansiona ora il qr code di attivazione",
      payment_scan_title: "Scaricata?",
      payment_approval_desc: "Potrebbero volerci ore come qualche giorno, ti contatteremo via mail all'indirizzo da te fornito non appena avremo la conferma del negozio",
      payment_approval_title: "Attendi la conferma del negozio per la disponibilità del noleggio incluso col self-guided tour.",
      payment_check_mail: "Controlla la MAIL!",
      payment_scan_download: "Scansiona per scarica l'app",
      payment_download: "Scarica la App",
      payment_or_scan_download: "Oppure scansiona per installare",
      payment_desc2: "Un'esperienza di navigazione in tempo reale che ti guiderà lungo il percorso fino a destinazione",
      payment_title2: "Scarica OUTDOORA per usare il nostro Self-guided Tour",
      payment_noworry: "Non preoccuparti",
    },
  };
  
  // Testo di consenso WhatsApp/SMS mostrato SOLO ai numeri USA/Canada (prefisso +1),
  // dove è richiesto un opt-in esplicito per gli SMS transazionali (compliance Brevo).
  // Volutamente ISOLATO da i18n/T: aggiungere qui una nuova lingua NON altera il
  // fallback globale della lingua del sito (che supporta solo en/it).
  // Le parole chiave STOP e HELP restano in inglese: sono i keyword reali che
  // l'utente deve inviare via SMS e che Brevo processa automaticamente.
  const SMS_CONSENT_I18N: { [k: string]: string } = {
    en: "I agree to receive WhatsApp/SMS messages only about my booking and the activation of the Outdoora app to navigate my self-guided tour. For SMS, reply STOP to opt out or HELP for assistance. Your mobile information will not be sold or shared with third parties for promotional or marketing purposes.",
    it: "Acconsento a ricevere messaggi WhatsApp/SMS solo riguardo alla mia prenotazione e all'attivazione dell'app Outdoora per navigare il mio self-guided tour. Per gli SMS, rispondi STOP per annullare l'iscrizione o HELP per assistenza. Le informazioni del tuo cellulare non saranno vendute né condivise con terze parti per scopi promozionali o di marketing.",
    fr: "J'accepte de recevoir des messages WhatsApp/SMS uniquement concernant ma réservation et l'activation de l'application Outdoora pour naviguer sur mon tour en autonomie. Pour les SMS, répondez STOP pour vous désabonner ou HELP pour obtenir de l'aide. Vos informations mobiles ne seront ni vendues ni partagées avec des tiers à des fins promotionnelles ou marketing.",
    de: "Ich stimme zu, WhatsApp-/SMS-Nachrichten nur zu meiner Buchung und zur Aktivierung der Outdoora-App für die Navigation meiner selbstgeführten Tour zu erhalten. Antworten Sie bei SMS mit STOP zum Abbestellen oder HELP für Unterstützung. Ihre Mobilfunkdaten werden nicht an Dritte für Werbe- oder Marketingzwecke verkauft oder weitergegeben.",
    es: "Acepto recibir mensajes de WhatsApp/SMS únicamente sobre mi reserva y la activación de la aplicación Outdoora para navegar mi tour autoguiado. Para los SMS, responde STOP para darte de baja o HELP para obtener ayuda. La información de tu móvil no se venderá ni se compartirá con terceros con fines promocionales o de marketing.",
    pt: "Concordo em receber mensagens de WhatsApp/SMS apenas sobre a minha reserva e a ativação da aplicação Outdoora para navegar no meu tour autoguiado. Para SMS, responda STOP para cancelar ou HELP para obter ajuda. As informações do seu telemóvel não serão vendidas nem partilhadas com terceiros para fins promocionais ou de marketing.",
    nl: "Ik ga ermee akkoord WhatsApp-/sms-berichten te ontvangen die uitsluitend betrekking hebben op mijn boeking en de activering van de Outdoora-app om mijn self-guided tour te navigeren. Antwoord bij sms met STOP om je af te melden of HELP voor hulp. Je mobiele gegevens worden niet verkocht of gedeeld met derden voor promotionele of marketingdoeleinden.",
  };

  // Ritorna il testo di consenso nella lingua corrente (fallback inglese).
  export const smsConsentText = (): string => {
    const lang = window.lang && SMS_CONSENT_I18N[window.lang] ? window.lang : "en";
    return SMS_CONSENT_I18N[lang];
  };

  export const T = (key: string, params?: any): string => {
    // La lingua è valida solo se esiste un dizionario corrispondente.
    // Per lingue non supportate (es. "de" per gli utenti dell'Alto Adige con
    // browser in tedesco) si ricade su "it", altrimenti i18n[lang] sarebbe
    // undefined e i18n[lang][key] lancerebbe un TypeError -> pagina bianca.
    const lang = window.lang && i18n[window.lang] ? window.lang : "it";
    // Fallback a catena: lingua scelta -> italiano -> la key stessa.
    let resp = i18n[lang][key];
    if (resp === undefined) resp = i18n.it[key];
    if (resp === undefined) resp = key;
    if (params) {
      return String(resp).replace(
        /{{(.*?)}}/g,
        (m: any, g1: string) => params[g1.trim()] || m
      );
    }
    return resp;
  };
  